// extracted by mini-css-extract-plugin
export var equalColumn = "_hv-0";